export default {
  root: {
    height: "100%"
  }
};
